import React from 'react';
import { Field } from 'react-final-form';
import { RenderDropdown } from 'forms';
import { useSelector } from 'react-redux';

import { selectSprayJustificationOptions } from './selectors';

interface Props {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
    disabled?: boolean;
}

export default function SprayJustificationDropdown(
    props: Props
): React.ReactElement {
    const {
        name,
        label,
        validate,
        nullOnUnmount = false,
        placeholder,
        disabled = false
    } = props;
    const options = useSelector(selectSprayJustificationOptions);

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label={label || 'Justification option'}
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={options}
            nullOnUnmount={nullOnUnmount}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
}
